export default __webpack_public_path__ + "fonts/Transducer-Bold.d654ff1182c39e27e58fac8818ca07a4.woff2";